import { render, staticRenderFns } from "./review.vue?vue&type=template&id=27592310&scoped=true"
import script from "./review.vue?vue&type=script&lang=ts"
export * from "./review.vue?vue&type=script&lang=ts"
import style0 from "./review.vue?vue&type=style&index=0&id=27592310&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27592310",
  null
  
)

export default component.exports